export const UserTypes = {
  Regular: 'regular',
  Free: 'free',
} as const;

export type UserType = typeof UserTypes[keyof typeof UserTypes];
